
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");
const Utils = require("chart.js");

@Component
export default class DeliveryDelayReport extends Vue {
	private chart: any = null;
	private delayReports: any = [];
	private loading: boolean = false;
	private year: number = new Date().getFullYear();

	private mounted() {
		this.loadReport();
	}

	private get years() {
		var lastYears = [];
		for (let index = new Date().getFullYear(); index >= 2012; index--) {
			lastYears.push(index);
		}
		return lastYears;
	}

	@Watch("year")
	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Report/GetDeliveryDelay?year=${this.year}`);
			const manufacturersResponse = await httpClient().get(`Manufacturer/GetManufacturers`);
			console.log(manufacturersResponse);
			this.delayReports = response.data;
			for (const report of this.delayReports) {
				const fertiger = manufacturersResponse.data.filter(
					(m: any) => m.id === report.fertigerId
				)[0];
				if (fertiger !== undefined) {
					report.fertigerId = fertiger.name;
				} else {
					console.log(report);
				}
			}
			this.updateDiagram();
		} catch (err) {
			console.error("Loading delay reports failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getDatasets() {
		var datasets: any = [
			{
				label: "Pünktlich",
				data: [...this.delayReports.map((r: any) => r.procentOnTime.toFixed(1))],
				backgroundColor: "#378805",
			},
			{
				label: "1 Tag verzögert",
				data: [...this.delayReports.map((r: any) => r.procentOneDayDelay.toFixed(1))],
				backgroundColor: "#ffad33",
			},
			{
				label: "2 Tage und mehr",
				data: [
					...this.delayReports.map((r: any) => r.procentMoreThenOneDayDelay.toFixed(1)),
				],
				backgroundColor: "#e10000",
			},
		];

		return datasets;
	}

	private updateDiagram() {
		const labels = this.delayReports.map((r: any) => `${r.fertigerId}`);

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "bar",
			// The data for our dataset
			data: {
				labels: labels,
				datasets: this.getDatasets(),
			},
			options: {
				plugins: {
					title: {
						display: true,
						text: "Lieferverzögerung",
					},
				},
				responsive: true,
				scales: {
					xAxes: [
						{
							stacked: true,
						},
					],
					yAxes: [
						{
							stacked: true,
							ticks: {
								min: 0, // minimum value
								max: 100, // maximum value
							},
						},
					],
				},
			},
		});
		this.chart.update();
	}
}
